import ActionsForm from '@/shared/mixins/actionsForm'
import AttachSearchForm from './search-form.js'
import Tools from '@/components/tools/Tools'

const AttachSearchData = {
  dataEnvio: null,
  nomeOriginal: null
}

export default {
  mixins: [ActionsForm],
  name: 'AttachSearch',
  data () {
    return {
      data: AttachSearchData,
      form: AttachSearchForm
    }
  },
  props: {
    parentComponent: {
      type: Object
    }
  },
  beforeDestroy () {
    this.onClearOptions()
  },
  methods: {
    onLoad () {
      this.onClearFilters()
    },
    onClearOptions () {
      this.form.nomeOriginal.value = null
      this.form.dataEnvio.value = null
    },
    onClearFilters () {
      Tools.SetFormDefaultValues(this.form)
      this.onClearOptions()
      this.parentComponent.filters = null
      this.parentComponent.onLoadAll()
    },
    onValidateFilters () {
      let result = true
      Tools.SetValueToSave(this.form, this.data)
      return result
    },
    onFilter () {
      if (this.onValidateFilters()) {
        this.$eventHub.emit('Filter', { filters: this.data })
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/attachments/components/search/search.js